import React from "react";
import { Link } from "gatsby";
import { FiArrowRight } from "react-icons/fi";

function AnnouncementBar() {
    return (
        <Link to="/#news" className="announcement-bar">
            <span className="announcement-bar-badge">
                <span className="announcement-bar-dot" aria-hidden="true" />
                Aktualno
            </span>
            <span className="announcement-bar-text">
                Muzejski vlak prihaja v Litijo
                <span className="announcement-bar-date"> · sobota, 13. junij 2026</span>
            </span>
            <span className="announcement-bar-cta">
                Preberi več <FiArrowRight />
            </span>
        </Link>
    );
}

export default AnnouncementBar;
